import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PayoutRateHistoryDialogComponent } from './payout-rate-history-dialog.component';

export interface PayoutRateHistoryDialogInput {
  userId: string;
  userName?: string;
}

@Injectable({
  providedIn: 'root',
})
export class PayoutRateHistoryDialogService {
  constructor(private readonly dialog: MatDialog) {}

  openDialog(input: PayoutRateHistoryDialogInput): void {
    this.dialog.open(PayoutRateHistoryDialogComponent, {
      data: input,
      width: '800px',
      maxWidth: '90vw',
      maxHeight: '90vh',
    });
  }
}
